import { useDispatch } from "react-redux";
import { ThunkDispatch, ThunkAction } from "redux-thunk";
import { AnyAction, Action } from "redux";
import { AppState } from "../interfaces/general/app-state";

export type ThunkDispatchType = ThunkDispatch<AppState , any, Action>;
export type ThunkResult<Result> = ThunkAction<Result, AppState, undefined, Action>;

export const useThunkDispatch  = () : ThunkDispatchType => useDispatch<ThunkDispatchType>();